<template>
    <div class="resume-select--container">
        <div class="inner-container">
            <div class="title">请选择简历</div>
            <ul>
                <li v-for="resume in $root.resumeList" :key="resume.resumeId" @click="resumeId = resume.resumeId">
                    <span>{{ resume.resumeName }}</span>
                    <input class="resume-radio"
                           :value="resume.resumeId"
                           type="radio"
                    />
                    <!-- v-model="resumeId" -->
                    <label :class="{active: resumeId === resume.resumeId}"></label>
                </li>
            </ul>
            <div class="apply" @click="delivery">立即申请</div>
        </div>
    </div>
</template>

<script>

import { handlerDelivery } from '../js/delivery';

export default {
    data() {
        return {resumeId: ''};
    },
    methods: {
        delivery() {
            handlerDelivery({
                wbtk: '',
                ...this.$root,
                resumeId: this.resumeId
            });
        }
    }
};
</script>
